import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import AuthGuard from './AuthGuard';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const UsersPage = Loadable(lazy(() => import('pages/users')));
const MembersPage = Loadable(lazy(() => import('pages/members')));
const MemberDetailPage = Loadable(lazy(() => import('pages/members/detail')));
const CreateMemberPage = Loadable(lazy(() => import('pages/members/create')));
const GroupsPage = Loadable(lazy(() => import('pages/groups')));
const GroupDetailPage = Loadable(lazy(() => import('pages/groups/detail')));
const CreateGroupPage = Loadable(lazy(() => import('pages/groups/create')));
const ContributionsPage = Loadable(lazy(() => import('pages/contributions')));
const ContributionDetailPage = Loadable(lazy(() => import('pages/contributions/detail')));
const CreateContributionPage = Loadable(lazy(() => import('pages/contributions/create')));
const LoansPage = Loadable(lazy(() => import('pages/loans')));
const CreateLoanPage = Loadable(lazy(() => import('pages/loans/create')));
const MeetingsPage = Loadable(lazy(() => import('pages/meetings')));
const CreateMeetingPage = Loadable(lazy(() => import('pages/meetings/create')));
const MeetingDetailPage = Loadable(lazy(() => import('pages/meetings/detail')));
const NotificationsPage = Loadable(lazy(() => import('pages/notifications')));
const ContactMessagesPage = Loadable(lazy(() => import('pages/contact-messages')));
const AdminApplicationsPage = Loadable(lazy(() => import('pages/admin-applications')));
const PlansPage = Loadable(lazy(() => import('pages/plans')));
const SubscriptionsPage = Loadable(lazy(() => import('pages/subscriptions')));
const BillingPage = Loadable(lazy(() => import('pages/billing')));
const ReportsPage = Loadable(lazy(() => import('pages/reports')));
const ProfilePage = Loadable(lazy(() => import('pages/profile')));
const CreateUserPage = Loadable(lazy(() => import('pages/users/create')));
const EditUserPage = Loadable(lazy(() => import('pages/users/edit')));
const ChatbotPage = Loadable(lazy(() => import('pages/ai/chatbot')));
const SmsMessagesPage = Loadable(lazy(() => import('pages/sms-messages')));
const WalletTransactionsPage = Loadable(lazy(() => import('pages/wallet-transactions')));
const WalletPurchasesPage = Loadable(lazy(() => import('pages/wallet-purchases')));
const TransactionCallbacksPage = Loadable(lazy(() => import('pages/transaction-callbacks')));
const MobileInactivitySettingsPage = Loadable(lazy(() => import('pages/settings/mobile-inactivity')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <DashboardLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'users',
      element: <UsersPage />
    },
    {
      path: 'users/create',
      element: <CreateUserPage />
    },
    {
      path: 'users/:userId/edit',
      element: <EditUserPage />
    },
    {
      path: 'members',
      element: <MembersPage />
    },
    {
      path: 'members/:memberId',
      element: <MemberDetailPage />
    },
    {
      path: 'members/create',
      element: <CreateMemberPage />
    },
    {
      path: 'groups',
      element: <GroupsPage />
    },
    {
      path: 'groups/create',
      element: <CreateGroupPage />
    },
    {
      path: 'groups/:groupId',
      element: <GroupDetailPage />
    },
    {
      path: 'contributions',
      element: <ContributionsPage />
    },
    {
      path: 'contributions/create',
      element: <CreateContributionPage />
    },
    {
      path: 'contributions/:groupId/:contributionId',
      element: <ContributionDetailPage />
    },
    {
      path: 'loans',
      element: <LoansPage />
    },
    {
      path: 'loans/create',
      element: <CreateLoanPage />
    },
    {
      path: 'meetings',
      element: <MeetingsPage />
    },
    {
      path: 'meetings/create',
      element: <CreateMeetingPage />
    },
    {
      path: 'meetings/:groupId/:meetingId',
      element: <MeetingDetailPage />
    },
    {
      path: 'notifications',
      element: <NotificationsPage />
    },
    {
      path: 'marketing/leads',
      element: <ContactMessagesPage />
    },
    {
      path: 'admin-applications',
      element: <AdminApplicationsPage />
    },
    {
      path: 'plans',
      element: <PlansPage />
    },
    {
      path: 'subscriptions',
      element: <SubscriptionsPage />
    },
    {
      path: 'billing',
      element: <BillingPage />
    },
    {
      path: 'sms-messages',
      element: <SmsMessagesPage />
    },
    {
      path: 'wallet-transactions',
      element: <WalletTransactionsPage />
    },
    {
      path: 'wallet-purchases',
      element: <WalletPurchasesPage />
    },
    {
      path: 'transaction-callbacks',
      element: <TransactionCallbacksPage />
    },
    {
      path: 'settings/mobile-inactivity',
      element: <MobileInactivitySettingsPage />
    },
    {
      path: 'reports',
      element: <ReportsPage />
    },
    {
      path: 'profile',
      element: <ProfilePage />
    },
    {
      path: 'ai/chatbot',
      element: <ChatbotPage />
    }
  ]
};

export default MainRoutes;
